import { useSelector } from 'react-redux';
function MyProfile() {
  const { userDetails } = useSelector((state) => {
    return state.auth?.successData ?? {};
  });
  return (
    <>
      <div className='bg-[#eef0f7] p-4 mt-3 rounded-lg'>
        <div>
          <h5 className='text-blue-700 font-bold font-sans'>My Profile</h5>
          <div className='flex flex-col  gap-3 *:min-w-max *:flex *:flex-col mt-3 '>
            <div className='flex-1 '>
              <span className=' mb-1'>User Name</span>
              <span className='font-bold'>{userDetails?.userName}</span>
            </div>
            <div className='flex-1 '>
              <span className=' mb-1'>Email</span>
              <span className='font-bold'>{userDetails?.email}</span>
            </div>
            <div className='flex-1 '>
              <span className=' mb-1'>Designation</span>
              <span className='font-bold'>{userDetails?.designation}</span>
            </div>
            <div className='flex-1 '>
              <span className=' mb-1'>Location</span>
              <span className='font-bold'>{userDetails?.location}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MyProfile;
